'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import styled, { useTheme } from 'styled-components';
import { isHalloween } from '../operators/isHalloween';
import { SpiderWebLeft, SpiderWebRight } from './SpiderWebs';
var ThemedPage = styled.div.withConfig({
  displayName: "ThemedErrorPage__ThemedPage",
  componentId: "c61xaz-0"
})(["background:", ";background-color:", ";background-size:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.errorPage.background;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.errorPage.backgroundColor;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.errorPage.backgroundSize;
});
export var ThemedErrorPage = function ThemedErrorPage(_ref4) {
  var children = _ref4.children;
  var theme = useTheme();
  return /*#__PURE__*/_jsxs(ThemedPage, {
    children: [isHalloween(theme) && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(SpiderWebLeft, {}), /*#__PURE__*/_jsx(SpiderWebRight, {})]
    }), children]
  });
};